import { useMutation } from '@tanstack/react-query'

import { UsersAPI } from '@makyoapp/makyo-sdk'

import { mutationKeys } from '@/lib/react-query/mutation-keys'

/**
 * useDeleteAccountMutation is a custom hook that uses useMutation from react-query to create a mutation for deleting a user account permanently.
 * It calls the ReqDeletePermanently method from UsersAPI.
 *
 * @returns {UseMutationResult} Result object from React Query's useMutation hook.
 */
export const useDeleteAccountMutation = () =>
  useMutation({
    mutationKey: [mutationKeys.login.deleteAccount],
    mutationFn: async () => {
      await UsersAPI.ReqDeletePermanently()
    },
  })

/**
 * useRestoreAccountMutation is a custom hook that uses useMutation from react-query to create a mutation for restoring a user account.
 * It calls the ReqRestore method from UsersAPI.
 *
 * @returns {UseMutationResult} Result object from React Query's useMutation hook.
 */
export const useRestoreAccountMutation = () =>
  useMutation({
    mutationKey: [mutationKeys.login.restoreAccount],
    mutationFn: () => UsersAPI.ReqRestore(),
  })
